/**
 * Синхронизация viewport, safe area и keyboard height.
 * В Telegram — через WebApp API. В обычном браузере — через window.innerHeight.
 */

let debounceTimer: ReturnType<typeof setTimeout> | null = null;

function syncVars(): void {
  if (typeof document === 'undefined') return;

  const root = document.documentElement;
  const tg = window.Telegram?.WebApp;

  if (tg?.viewportHeight != null && tg?.viewportStableHeight != null) {
    root.style.setProperty('--tg-viewport-height', `${tg.viewportHeight}px`);
    root.style.setProperty(
      '--tg-viewport-stable-height',
      `${tg.viewportStableHeight}px`
    );

    const kbHeight = Math.max(0, tg.viewportStableHeight - tg.viewportHeight);
    root.style.setProperty('--keyboard-height', `${kbHeight}px`);
  } else {
    const h = `${window.innerHeight}px`;
    root.style.setProperty('--tg-viewport-height', h);
    root.style.setProperty('--tg-viewport-stable-height', h);
    root.style.setProperty('--keyboard-height', '0px');
  }

  if (tg?.safeAreaInset) {
    root.style.setProperty('--safe-area-top', `${tg.safeAreaInset.top}px`);
    root.style.setProperty(
      '--safe-area-bottom',
      `${tg.safeAreaInset.bottom}px`
    );
  }

  if (tg?.contentSafeAreaInset) {
    root.style.setProperty(
      '--content-safe-area-top',
      `${tg.contentSafeAreaInset.top}px`
    );
  }
}

function debouncedSync(): void {
  if (debounceTimer) clearTimeout(debounceTimer);
  debounceTimer = setTimeout(syncVars, 50);
}

export function setupTelegramViewport(): void {
  if (typeof window === 'undefined') return;

  const tg = window.Telegram?.WebApp;

  if (tg?.expand) {
    tg.expand();
  }

  syncVars();

  window.addEventListener('resize', debouncedSync);

  if (tg?.onEvent) {
    tg.onEvent('viewportChanged', syncVars);
    tg.onEvent('safeAreaChanged', syncVars);
    tg.onEvent('contentSafeAreaChanged', syncVars);
  }
}

export function setupBrowserViewport(): void {
  if (typeof window === 'undefined') return;

  syncVars();
  window.addEventListener('resize', debouncedSync);
}
